<template>
    <Dialog size="long">
        <template v-slot:title>
            無線機設定の割り当て
        </template>

        <template v-slot:body>
            <div style="height: 90%; margin: 4px">
                <div class="inner-panel-header">
                    <div class="inner-panel-title" style="width: 100%;">
                        <div class="inner-panel-title-left" v-t="'message.title_assignment_selectedIpRadio'">
                        </div>
                    </div>
                </div>
                <div id="selected-user" class="inner-panel-dialog" style="height: 60%; width: 100%;">
                    <div class="selected-item-field">
                        <span v-for="tag in selectionColumn.data" v-bind:key="tag.id">
                            <div class="selectedTag">
                                <span class="selectedTag-name" style="max-width: 100%;">{{ tag.displayName }}</span>
                                <span class="closeTag"></span>
                            </div>
                        </span>
                    </div>
                </div>

                <hr class="dialog-hr">
                <div class="inner-panel-header">
                    <div class="inner-panel-title" style="width: 100%;">
                        <div class="inner-panel-title-left" v-t="'message.item_ip_radio'">
                        </div>
                    </div>
                </div>
                <div style="margin: 4px 80px">
                    <el-select style="width: 100%;"
                               v-model="selectedModel"
                               :placeholder="$t('message.action_ip_radio_select_model')"
                               @change="onModelSelect">
                        <el-option
                            v-for="item in modelList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>

                    <el-tree style="overflow: auto; height: calc(100% - 40px)"
                             class="settings-tree"
                             :data="settingsToShow"
                             :props="treeProps"
                             node-key="id"
                             ref="settingsTree"
                             highlight-current
                             @node-click="onNodeClick"
                    >
                    </el-tree>
                </div>
            </div>
        </template>

        <template v-slot:button>
            <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
            <el-button class="dialog-ok-button" :disabled="disableSave" @click="handleSaveClick" v-t="'message.button_save'"></el-button>
        </template>
    </Dialog>

</template>

<script>
import server from "@/components/ServerApi.js";
import constants from "@/components/constants.js";
import commonUtil from '@/components/commonutil.js';
import Dialog from '@/components/pc/common/Dialog.vue'

export default {
    components: {
        Dialog
    },

    props:['appData','selectionColumn'],

    data() {
        return {
            // Element UI の el-tree 用 props
            treeProps: {
                label: 'displayName'
            },

            selectedModel: null,

            modelList: [],
            settingsToShow: [],
            selectedSetting: null,
        }
    },

    computed: {
        disableSave() {
            if (this.selectedModel === null) {
                return true;
            }

            if (this.selectedSetting === null) {
                return true;
            }

            return false;
        },
    },

    created() {
        this.fetchModelList()
        this.initialize()
    },

    methods: {

        initialize() {
            this.selectedModel = null;
            this.selectedSetting = null;
            this.settingsToShow = [];
        },

        selectInitialModel() {
            if (this.modelList.length === 0) {
                return;
            }
            const initialModel = constants.RADIO_MODEL_P51;
            if (initialModel != null && this.modelList.some((model) => model.value === initialModel)) {
                this.onModelSelect(initialModel);
            }else{
                this.onModelSelect(this.modelList[0].value);
            }
            this.syncSelectedSetting(this.resolveInitialSettingName());
        },

        resolveInitialSettingName() {
            const selectedIpRadios = this.selectionColumn.data;
            if (selectedIpRadios.length === 0) {
                return null;
            }

            const firstSettingName = selectedIpRadios[0].settingName;
            if (firstSettingName == null || firstSettingName === '') {
                return null;
            }

            const hasDifferentSetting = selectedIpRadios.some(
                (ipRadio) => ipRadio.settingName !== firstSettingName
            );

            if (hasDifferentSetting) {
                return null;
            }

            return firstSettingName;
        },

        onModelSelect(model) {
            this.selectedModel = model;
            this.selectedSetting = null;
            this.fetchSettingList();
        },

        async fetchModelList() {
            let response
            try {
                response = await server.post('/getipradiomodellist')
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "fetchModelList", error);
            }

            const responseStatus = response.data.status;
            switch (responseStatus) {
                case constants.STATUS_SUCCESS:
                    this.modelList = response.data.modelList.map(model => ({value:model, label:model}));
                    this.selectInitialModel();
                    break;
                default:
                    commonUtil.putExceptionErrorMessage(this, "fetchModelList", response.data.status);
                    break;
            }
        },

        async fetchSettingList() {
            let response
            try {
                response = await server.post('/getipradiosettinglist', {model: this.selectedModel})
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "fetchSettingList", error);
            }

            const responseStatus = response.data.status;
            switch (responseStatus) {
                case constants.STATUS_SUCCESS:
                    this.settingsToShow = response.data.settings;
                    break;
                default:
                    commonUtil.putExceptionErrorMessage(this, "fetchSettings", response.data.status);
                    break;
            }
        },

        syncSelectedSetting(initialSettingName) {
            if (initialSettingName == null) {
                this.$nextTick(() => {
                    this.$refs.settingsTree?.setCurrentKey(null);
                });
                return;
            }

            const assignedSetting = this.settingsToShow.find((setting) => setting.displayName === initialSettingName);
            if (assignedSetting == null) {
                this.$nextTick(() => {
                    this.$refs.settingsTree?.setCurrentKey(null);
                });
                return;
            }

            this.selectedSetting = assignedSetting;
            this.$nextTick(() => {
                this.$refs.settingsTree?.setCurrentKey(assignedSetting.id);
            });
        },

        handleSaveClick() {
            let selectIdList = [];
            for (let selected of this.selectionColumn.data){
                selectIdList.push(selected.id);
            }
            this.$emit('save', this.selectedSetting.id, selectIdList)
        },

        onNodeClick(data) {
            this.selectedSetting = data;
        },

        renderContent(h, { node, data }) {
            return h(
                'span',
                {
                    style: {
                        display: 'flex',
                        alignItems: 'center'
                    }
                },
                [
                    h('el-radio', {
                        class: 'radio-only',
                        props: {
                            value: this.selectedSetting,
                            label: data
                        },
                        on: {
                            input: (val) => {
                                this.selectedSetting = val;
                            }
                        }
                    }),
                    h(
                        'span',
                        {
                            class: 'tree-node-label',
                            style: {
                                marginLeft: '0px'
                            }
                        },
                        node.label
                    )
                ]
            );
        },


    }
}
</script>

<style scoped>

:deep(.settings-tree .el-tree-node__expand-icon) {
    display: none !important;
}
:deep(.radio-only .el-radio__label) {
    display: none;
}
:deep(.tree-node-label) {
  font-size: 16px;
}
.selectedTag {
  display: inline-block;
  border: 1px solid;
  border-radius: 30px;
  border-color: #1F2E4B;
  color: #1F2E4B;
  margin: 5px;
  padding: 6px 10px;
  white-space: nowrap;
  word-break: break-word;
  text-align: justify;
}
.selectedTag > .selectedTag-name {
  display: inline-block;
  vertical-align: middle;
  white-space: normal;
  max-width: 100%;
}

</style>
